import React, { useEffect, useState } from "react";
import { Box, Card, Chip, Typography } from "@mui/material";
import StatusCellRenderer from "../../trips/columnDefComponents/StatusCellRenderer";
import ApprovalCellRenderer from "../../trips/columnDefComponents/ApprovalCellRenderer";
import { TripAcceptance, TripDetails } from "../../../types/api";
import { ApprovalStatus } from "../../../types/FilterEnums";
import { tripDetailsCard } from "../style";
import { useWindowSize } from "../../../utils/hooks/useWindowSize";
import { useTripContext } from "../../../context/tripsContext";
import LastUpdate from "../../../components/lastUpdate/lastUpdate";
import { useTranslation } from "react-i18next";

interface TripDetailsCardProps {
  tripDetails: TripDetails;
  tripAcceptance: TripAcceptance | null;
  tripId: number;
}

const TripDetailsCard: React.FC<TripDetailsCardProps> = ({
  tripDetails,
  tripAcceptance,
  tripId,
}) => {
  const { fetchLastUpdateData, lastUpdateData } = useTripContext();
  const [geocodingResult, setGeocodingResult] = useState(false);
  const {t} = useTranslation();
  // Effettua la chiamata per ottenere i dati di aggiornamento
  useEffect(() => {
    if (tripDetails) {
      const orderList = tripDetails.relatedOrders.map((tmsKey) => {
        // Estrarre i valori da ogni tmsKey
        const [erpSystem, erpCompany, orderType, orderNumber] = tmsKey.split('_');
  
        return {
          erpSystem,
          erpCompany: Number(erpCompany),
          orderType: Number(orderType),
          orderNumber,
        };
      });

      // Chiamare fetchLastUpdateData con orderList
      fetchLastUpdateData(orderList);
    }
  }, [tripDetails, fetchLastUpdateData]);
  


  const handleGeocodingResult = (result: boolean) => {
    setGeocodingResult(result);
  };

  function formatApprovalDate(isoDate: string): string | null {
    if (isoDate === "0001-01-01T00:00:00+00:00") {
      return null;
    }
    const date = new Date(isoDate);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // I mesi vanno da 0 a 11
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }
  const windowWidth = useWindowSize();
  const isMobile = windowWidth < 700;

  useEffect(() => {
    if (geocodingResult) {
    }
  }, [geocodingResult, tripId, tripDetails]);

  return (
    <Card
      elevation={0}
      sx={isMobile ? tripDetailsCard.cardM : tripDetailsCard.cardD}
    >


      <Box sx={isMobile ? tripDetailsCard.wrapperM : tripDetailsCard.wrapperD}>
        <Typography sx={tripDetailsCard.tms}>
          {tripDetails.tmsObjectNumber}
        </Typography>
        <Box
          sx={
            isMobile
              ? tripDetailsCard.chipsWrapperM
              : tripDetailsCard.chipsWrapperD
          }
        >
          <Box sx={tripDetailsCard.subWrapper}>
            <StatusCellRenderer value={tripDetails.status} />
          </Box>
          <Chip
            sx={tripDetailsCard.chip}
            label={
              <Typography sx={tripDetailsCard.label}>
                {tripDetails.totalAmount.toFixed(2)}{" "}
                {tripDetails.totalAmountCurrency}
              </Typography>
            }
            variant="outlined"
          />
        </Box>
      </Box>
      <Box sx={tripDetailsCard.box}>
        {tripAcceptance && (
          <ApprovalCellRenderer
            value={tripAcceptance.approvalStatus}
            tripId={tripId}
            tmsKey={tripDetails.tmsKey}
            tripAcceptance={tripAcceptance}
          />
        )}
        {tripAcceptance &&
          tripAcceptance.approvalStatus !== ApprovalStatus.TO_APPROVE && (
            <>
             {tripAcceptance.approvalStatusUser === "UDM" ? (
              <Typography sx={tripDetailsCard.acceptanceText}>
               { t('screens.trips.approval.on')} {formatApprovalDate(tripAcceptance.approvalStatusUpdate)}
              </Typography>
            ) : formatApprovalDate(tripAcceptance.approvalStatusUpdate) ? (
              <Typography sx={tripDetailsCard.acceptanceText}>
                 { t('screens.trips.approval.on')} {formatApprovalDate(tripAcceptance.approvalStatusUpdate)} { t('screens.trips.approval.by')}
                <strong style={tripDetailsCard.acceptanceValue}>
                  {tripAcceptance.approvalStatusUser}
                </strong>
              </Typography>
            ) : (
              <Typography sx={tripDetailsCard.acceptanceText} />
            )}
            </>
          )}
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          columnGap: "10px",
          marginTop: "24px",
        }}
      >
        <LastUpdate
          onGeocodingResult={handleGeocodingResult}
          lastUpdateData={lastUpdateData}
        />
      </Box>

    </Card>
  );
};

export default TripDetailsCard;
